import React from 'react'
import {Row, Block} from 'jsxstyle'

interface CustomCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  borderColor?: string
  backgroundColorChecked?: string
  backgroundColorUnchecked?: string
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  borderColor = '#000000',
  backgroundColorChecked = '#000000',
  backgroundColorUnchecked = '#EDEEEF',
}) => {
  const handleClick = () => onChange(!checked)

  return (
    <Row
      width="16px"
      height="16px"
      border={`1.5px solid ${borderColor}`}
      borderRadius="4px"
      backgroundColor={checked ? backgroundColorChecked : backgroundColorUnchecked}
      cursor="pointer"
      alignItems="center"
      justifyContent="center"
      transition="background-color 0.2s ease"
      props={{onClick: handleClick}}
    >
      {checked && (
        <Block color="#FFFFFF" fontWeight="bold">
          ✓
        </Block>
      )}
    </Row>
  )
}

export default CustomCheckbox
